import React from "react";
import "../css/healthnews.css";
import Navbar from "../Navbar";

export default function HealthCare4() {
  return (
    <>
      <Navbar />
      <div className="container" id="white">
        {/* Main Article */}
        <article className="main-article" id="orange">
          <div className="grid-layout">
            {/* Main Content */}
            <div className="main-content">
              {/* Featured Article */}
              <div className="featured-articl">
                <img
                  src="./images/Syria.jpg"
                  alt="Business people in a hallway"
                  className="featured-image"
                />

                <h1>
                  After 13 years of conflict and crisis, children continue to
                  pay the heaviest price.
                </h1>

                <div className="author-info">
                  <span>By Kelly Phillips Erb</span>
                  <span className="separator">|</span>
                  <span>EI Staff</span>
                </div>
                <div className="news-showcase">
                  <p>
                   
                    Thirteen years of crisis have upended the lives of children
                    and their families across Syria. Protracted conflict,
                    economic decay, disease outbreaks and multiple earthquakes
                    in early 2023, coupled with mass displacement, widespread
                    damaged infrastructure and limited humanitarian access have
                    left millions of children in need of humanitarian
                    assistance. With violence escalating in late November 2024,
                    UNICEF has reiterated its commitment to remain on the
                    ground, working alongside our partners to deliver
                    life-saving assistance to children and their families.
                    Children in Syria are facing one of the most complex
                    emergencies in the world. Around 7.5 million children in
                    Syria need humanitarian assistance because of the worsening
                    economic crisis, mass displacement, and devastated public
                    infrastructure. The country is also still grappling with the
                    aftermath of severe human and material damage from
                    catastrophic earthquakes and aftershocks in February 2023.
                    Around 85 per cent of families in Syria struggle to make
                    ends meet. The ongoing economic crisis is worsening negative
                    coping mechanisms and particularly affecting female-headed
                    households while contributing to the normalization of
                    gender-based violence and child exploitation. Years of
                    conflict have forced many children and families to flee to
                    safer areas, resulting in considerable internal
                    displacement. Due to the level of poverty associated with
                    migrating populations, the most vulnerable children and
                    their families often end up in slums if they move to urban
                    areas. The situation was compounded in late September 2024
                    by an influx of displaced people crossing from Lebanon into
                    Syria and by an escalation of hostilities from late November
                    2024. Meanwhile, the collapsing health care system, lack of
                    access to safe water, poor sanitation and increasing food
                    insecurity has resulted not only in increased vulnerability
                    to fast-spreading waterborne and vaccine-preventable
                    diseases, but also sparked a dramatic increase in
                    malnutrition among children.
                  </p>
                </div>
              </div>
              {/* Secondary Articles Grid */}
              <div className="secondary-articles">
                {/* Article 1 */}
                <div className="articl">
                  <a href="#">
                    <img src="./images/trump.png" alt="Capitol building" />
                  </a>
                  <a href="#" className="anchor">
                    <h2>
                      With A Government Shutdown Deadline Looming, IRS Funding
                      Hangs In The Balance
                    </h2>
                  </a>
                  <div className="author-info">
                    By Kelly Phillips Erb | TSD Staff
                  </div>
                </div>
                {/* Article 2 */}
                <div className="articl">
                  <a href="#">
                    <img src="./images/trump.png" alt="Stock market data" />
                  </a>
                  <a href="#" className="anchor">
                    <h2>
                      America's Top 100 Mid-Cap Stocks: Meet The Companies
                      Powering The AI Boom
                    </h2>
                  </a>

                  <div className="author-info">By Hank Tucker | TSD Staff</div>
                </div>
              </div>
            </div>
            {/* Sidebar */}
            <aside className="sidebar">
              {/* Sidebar Article 1 */}
              <div className="sidebar-article">
                <a href="#">
                  <img src="./images/trump.png" alt="Tax document review" />
                </a>
                <a href="#" className="anchor">
                  <h2>We Need A Big, Fat Tax Cut Fast</h2>
                </a>
                <div className="author-info">By Steve Forbes | TSD Staff</div>
              </div>
              {/* Sidebar Article 2 */}
              <div className="sidebar-articl">
                <a href="#">
                  <img src="./images/trump.png" alt="Small business owner" />
                </a>
                <a href="#" className="anchor">
                  <h2>
                    How A New SBA Lending Rule Gives Buyers The Chance To Cut
                    Deals Like Private Equity Pros
                  </h2>
                </a>

                <div className="author-info">
                  By Brandon Kochkodin | TSD Staff
                </div>
              </div>
              <div className="sidebar-articl">
                <a href="#">
                  <img src="./images/trump.png" alt="Small business owner" />
                </a>
                <a href="#" className="anchor">
                  <h2>
                    How A New SBA Lending Rule Gives Buyers The Chance To Cut
                    Deals Like Private Equity Pros
                  </h2>
                </a>

                <div className="author-info">
                  By Brandon Kochkodin | TSD Staff
                </div>
              </div>
              <div className="sidebar-articl">
                <a href="#">
                  <img src="./images/trump.png" alt="Small business owner" />
                </a>
                <a href="#" className="anchor">
                  <h2>
                    How A New SBA Lending Rule Gives Buyers The Chance To Cut
                    Deals Like Private Equity Pros
                  </h2>
                </a>

                <div className="author-info">
                  By Brandon Kochkodin | TSD Staff
                </div>
              </div>
            </aside>
          </div>
        </article>
      </div>
    </>
  );
}
